import { Routes, Route, Outlet } from "react-router-dom";
import {
  BlogDetails,
  CategoriesPage,
  Home,
  LoginPage,
  SignupPage,
  WriterPage,
} from "./pages";
import Loading from "./components/Loading";
import { Footer, Navbar } from "./components";
import Blogs from "./pages/Blogs";
import CreateBlog from "./pages/blog/CreateBlog";
import BlogListPopup from "./pages/bloglist/BlogListPopup";
import AdminDetails from "./pages/admin/AdminDetails";
import UserAccount from "./pages/user/UserAccount";

function Layout() {
  return (
    <div className='w-full flex flex-col min-h-screen px-4 md:px-10 2xl:px-28'>
      <Navbar />
      <div className='flex-1'>
        <Outlet />
      </div>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <main>
      <div className={`w-full min-h-sreen relative dark:bg-[#020b19] bg-white`}>
        <Routes>
          <Route element={<Layout />}>
            <Route path='/' element={<Home />} />
            <Route path='/category' element={<CategoriesPage />} />
            <Route path='/create-blog' element={<BlogListPopup />} />
            <Route path='/blogs' element={<Blogs />} />
            <Route path='/:slug/:id?' element={<BlogDetails />} />
            <Route path='/writer/:id' element={<WriterPage />} />
            <Route path='/admin/:id' element={<AdminDetails />} />

            <Route path='/users/profile/me' element={<UserAccount />} />
          </Route>

          <Route path='/sign-up' element={<SignupPage />} />
          <Route path='/sign-in' element={<LoginPage />} />
        </Routes>
      </div>
    </main>
  );
}

export default App;
